import bbox from '@turf/bbox'
import type { Geometry } from 'geojson'
import type { MapRef } from 'react-map-gl'

type Bounds = [[number, number], [number, number]]

const DEFAULT_ZOOM = 16
const MIN_ZOOM = 4
const MAX_ZOOM = 18

function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(value, max))
}

function getBBox(parcels: { geometry: Geometry }[]) {
  const collection = {
    type: 'FeatureCollection',
    features: parcels.map((parcel) => ({
      type: 'Feature',
      geometry: parcel.geometry,
      properties: {},
    })),
  }

  return bbox(collection)
}

export function calculateIdealZoom(
  mapRef: MapRef | null,
  parcels: { geometry: Geometry }[]
) {
  if (!mapRef || parcels.length === 0) return DEFAULT_ZOOM

  const map = mapRef.getMap()
  const [minLng, minLat, maxLng, maxLat] = getBBox(parcels)

  const bounds: Bounds = [
    [minLng, minLat],
    [maxLng, maxLat],
  ]

  const camera = map.cameraForBounds(bounds, { padding: 50 })

  if (!camera) return DEFAULT_ZOOM

  return clamp(Math.floor(camera.zoom), MIN_ZOOM, MAX_ZOOM)
}
